// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rxrj","left":"styles_left__2jgwx","desktopActions":"styles_desktopActions__11sga","title":"styles_title__ExWD4"};